const initHistoryVideo = () => {
  const containers = document.querySelectorAll('.hs-single-video');

  containers.forEach((container) => {
    const youtubeId = container.dataset.youtubeId;
    if (!youtubeId) return;

    const player = container.querySelector('.hs-single-video-player');
    const playBtn = container.querySelector('.hs-single-video-play');

    if (!player || !playBtn) return;

    const launchVideo = () => {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'Video player');

      player.innerHTML = '';
      player.appendChild(iframe);
    };

    playBtn.addEventListener('click', launchVideo);
  });
};

export default initHistoryVideo;
